import { getUserDetails } from "utils/localStorageServices";
import moment from "moment";

export const validateToken = () => {
  const tokenObject = getUserDetails();
  const token = tokenObject?.token;
  const tokenExpiry = tokenObject?.expiresIn;

  if (!tokenObject || !token) return false;

  // Some login responses may not include expiresIn in iframe/add-on flows.
  // Avoid false negatives that cause redirect loops when a token exists.
  if (!tokenExpiry) return true;

  let expiryMoment = moment(tokenExpiry);

  // Handle numeric epoch values if returned as number/string.
  if (!expiryMoment.isValid()) {
    const numeric = Number(tokenExpiry);
    if (!Number.isNaN(numeric) && Number.isFinite(numeric)) {
      // Treat large values as milliseconds, otherwise seconds.
      expiryMoment = numeric > 1e12 ? moment(numeric) : moment.unix(numeric);
    }
  }

  if (!expiryMoment.isValid()) return true;

  return expiryMoment.isAfter(moment());
};
